import W from "@babel/runtime/helpers/esm/objectSpread2";
import M from "@babel/runtime/helpers/esm/slicedToArray";
import T from "@babel/runtime/helpers/esm/classCallCheck";
import X from "@babel/runtime/helpers/esm/createClass";
import f from "@babel/runtime/helpers/esm/assertThisInitialized";
import Y from "@babel/runtime/helpers/esm/inherits";
import A from "@babel/runtime/helpers/esm/createSuper";
import s from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as K } from "@semcore/utils/lib/core/index";
import U, { sstyled as H, assignProps as L, Component as V } from "@semcore/core";
import $ from "react";
import { findDOMNode as w } from "react-dom";
import { Box as P } from "@semcore/flex-box";
import { getNodeByRef as F } from "@semcore/utils/lib/ref";
import N from "@semcore/utils/lib/enhances/contextEnhance";
var I = (
  /*__reshadow_css_start__*/
  (K.insert(
    /*__inner_css_start__*/
    ".___SScrollBar_1u1a7_gg_{position:absolute;display:flex}.___SScrollBar_1u1a7_gg_._orientation_vertical_1u1a7_gg_{top:var(--intergalactic-spacing-1x, 4px);right:0;width:8px;height:calc(100% - var(--offsetSum_1u1a7) - var(--intergalactic-spacing-2x, 8px));justify-content:center}.___SScrollBar_1u1a7_gg_._orientation_horizontal_1u1a7_gg_{bottom:0;height:12px;align-items:center;width:calc(100% - var(--offsetSum_1u1a7) - var(--intergalactic-spacing-2x, 8px))}.___SSlider_1u1a7_gg_{cursor:pointer;width:6px;height:6px;border-radius:4px;background-color:var(--intergalactic-scroll-bar-background, rgba(25, 27, 35, 0.3))}",
    "1u1a7_gg_"
  ), {
    __SScrollBar: "___SScrollBar_1u1a7_gg_",
    _orientation_vertical: "_orientation_vertical_1u1a7_gg_",
    "--offsetSum": "--offsetSum_1u1a7",
    _orientation_horizontal: "_orientation_horizontal_1u1a7_gg_",
    __SSlider: "___SSlider_1u1a7_gg_"
  })
), j = /* @__PURE__ */ $.createContext(!1), k = 50, Z = function(v, d, t) {
  if (!(!v || !(d || t))) {
    var r = v.scrollWidth, l = v.clientWidth, a = v.scrollHeight, e = v.clientHeight, i = v.scrollLeft, o = v.scrollTop, n = r - l, u = a - e;
    d && (d.setAttribute("aria-valuenow", Math.floor(i)), d.setAttribute("aria-valuemax", n)), t && (t.setAttribute("aria-valuenow", Math.floor(o)), t.setAttribute("aria-valuemax", u));
  }
}, x = /* @__PURE__ */ function(B) {
  Y(d, B);
  var v = A(d);
  function d() {
    var t;
    T(this, d);
    for (var r = arguments.length, l = new Array(r), a = 0; a < r; a++)
      l[a] = arguments[a];
    return t = v.call.apply(v, [this].concat(l)), s(f(t), "$bar", null), s(f(t), "$slider", null), s(f(t), "sliderStyle", {
      width: k,
      height: k
    }), s(f(t), "kefScroll", {
      x: 0,
      y: 0
    }), s(f(t), "kefBar", {
      x: 0,
      y: 0
    }), s(f(t), "_scroll", {
      left: 0,
      top: 0
    }), s(f(t), "_mouse", {
      pageX: 0,
      pageY: 0
    }), s(f(t), "state", {
      visibleScroll: !1
    }), s(f(t), "refBar", function(e) {
      var i = w(e);
      t.$bar = i;
      var o = t.getOrientation(), n = t.asProps, u = n.horizontalBarRef, c = n.verticalBarRef;
      o === "horizontal" && u && (u.current = i), o === "vertical" && c && (c.current = i), Z(t.$container, u == null ? void 0 : u.current, c == null ? void 0 : c.current);
    }), s(f(t), "refSlider", function(e) {
      t.$slider = w(e);
    }), s(f(t), "calculate", function() {
      if (t.$container) {
        var e = t.calculateVisibleScroll();
        t.setState({
          visibleScroll: e
        }, function() {
          if (!(!t.$container || !t.$bar || !t.$slider)) {
            var i = t.getOrientation();
            t.sliderStyle = t.calculateSliderStyle(), t.kefBar = t.calculateKefBar(), t.kefScroll = t.calculateKefScroll(), i === "horizontal" ? t.$slider.style.width = "".concat(t.sliderStyle.width, "px") : i === "vertical" && (t.$slider.style.height = "".concat(t.sliderStyle.height, "px")), t.handleScroll();
          }
        });
      }
    }), s(f(t), "handleScroll", function() {
      if (!(!t.$container || !t.$slider)) {
        var e = t.$container, i = e.scrollTop, o = e.scrollLeft, n = t.getOrientation();
        n === "horizontal" ? t.$slider.style.transform = "translateX(".concat(o * t.kefScroll.x, "px)") : n === "vertical" && (t.$slider.style.transform = "translateY(".concat(i * t.kefScroll.y, "px)"));
      }
    }), s(f(t), "handleSelectStartDocument", function(e) {
      return e.preventDefault();
    }), s(f(t), "handleMouseMoveDocument", function(e) {
      var i = e.pageX, o = e.pageY, n = t._scroll, u = n.left, c = n.top, h = t.kefScroll, p = h.x, _ = h.y, g = t.getOrientation();
      g === "horizontal" ? t.$container.scrollLeft = t.calculateScrollByDiff(i, t._mouse.pageX, u, p) : g === "vertical" && (t.$container.scrollTop = t.calculateScrollByDiff(o, t._mouse.pageY, c, _));
    }), s(f(t), "handleMouseUpDocument", function() {
      document.removeEventListener("mousemove", t.handleMouseMoveDocument, !0), document.removeEventListener("mouseup", t.handleMouseUpDocument, !0), document.removeEventListener("selectstart", t.handleSelectStartDocument, !0);
    }), s(f(t), "handleMouseDownSlider", function(e) {
      e.stopPropagation(), t._mouse = {
        pageX: e.pageX,
        pageY: e.pageY
      };
      var i = t.$container, o = i.scrollLeft, n = i.scrollTop;
      t._scroll = {
        left: o,
        top: n
      }, document.addEventListener("mousemove", t.handleMouseMoveDocument, !0), document.addEventListener("mouseup", t.handleMouseUpDocument, !0), document.addEventListener("selectstart", t.handleSelectStartDocument, !0);
    }), s(f(t), "handleMouseDownBar", function(e) {
      e.stopPropagation();
      var i = e.pageX, o = e.pageY, n = window, u = n.pageXOffset, c = n.pageYOffset, h = t.$bar.getBoundingClientRect(), p = h.left, _ = h.top, g = t.getOrientation();
      g === "horizontal" ? t.$container.scrollLeft = t.calculateScrollByClick(p, u, i, t.kefBar.x, t.kefScroll.x) : g === "vertical" && (t.$container.scrollTop = t.calculateScrollByClick(_, c, o, t.kefBar.y, t.kefScroll.y));
    }), t;
  }
  return X(d, [{
    key: "$container",
    get: function() {
      return F(this.asProps.container);
    }
  }, {
    key: "calculateVisibleScroll",
    value: function() {
      var r = this.getOrientation(), l = this.calculateOrientation(), a = M(l, 2), e = a[0], i = a[1];
      return e && r === "horizontal" ? !0 : !!(i && r === "vertical");
    }
  }, {
    key: "calculateKefScroll",
    value: function() {
      var r = this.$container, l = r.clientWidth, a = r.clientHeight, e = r.scrollWidth, i = r.scrollHeight, o = this.$bar, n = o.clientWidth, u = o.clientHeight, c = this.sliderStyle, h = c.width, p = c.height;
      return {
        x: (n - h) / (e - l),
        y: (u - p) / (i - a)
      };
    }
  }, {
    key: "calculateKefBar",
    value: function() {
      var r = this.$bar, l = r.clientWidth, a = r.clientHeight, e = this.sliderStyle, i = e.width, o = e.height;
      return {
        x: (l - i) / l,
        y: (a - o) / a
      };
    }
  }, {
    key: "calculateSliderStyle",
    value: function() {
      var r = this.$bar, l = r.clientWidth, a = r.clientHeight, e = this.$container, i = e.scrollWidth, o = e.scrollHeight, n = function(c, h) {
        var p = Math.min(c / h, 1);
        return Math.round(c * p);
      };
      return {
        width: Math.max(n(l, i), k),
        height: Math.max(n(a, o), k)
      };
    }
  }, {
    key: "calculateScrollByClick",
    value: function(r, l, a, e, i) {
      var o = r + l, n = (a - o) * e;
      return n / i;
    }
  }, {
    key: "calculateScrollByDiff",
    value: function(r, l, a, e) {
      var i = r - l, o = a * e + i;
      return o / e;
    }
  }, {
    key: "calculateOrientation",
    value: function() {
      if (!this.$container) return [!1, !1];
      var r = this.$container, l = r.scrollWidth, a = r.scrollHeight, e = r.clientWidth, i = r.clientHeight;
      return [l > e, a > i];
    }
  }, {
    key: "getOrientation",
    value: function() {
      if (this.asProps.orientation !== void 0) return this.asProps.orientation;
      var r = this.calculateOrientation(), l = M(r, 2), a = l[0], e = l[1];
      if (e) return "vertical";
      if (a) return "horizontal";
    }
  }, {
    key: "subscribe",
    value: function(r) {
      r && (r.addEventListener("scroll", this.handleScroll), r.addEventListener("calculate", this.calculate));
    }
  }, {
    key: "unsubscribe",
    value: function(r) {
      r && (r.removeEventListener("scroll", this.handleScroll), r.removeEventListener("calculate", this.calculate));
    }
  }, {
    key: "getSliderProps",
    value: function() {
      return {
        ref: this.refSlider,
        onMouseDown: this.handleMouseDownSlider
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.subscribe(this.$container);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unsubscribe(this.$container);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.asProps, l, a = P, e = this.asProps, i = e.styles, o = e.uid, n = e.position, u = e.container, c = e.orientation, h = e.hideFromScreenReaders, p = this.state.visibleScroll, _ = this.asProps, g = _.leftOffset, m = _.rightOffset, S = _.topOffset, y = _.bottomOffset;
      if (!p)
        return null;
      var b = 0;
      if (c === "horizontal" && (g && (b += g), m && (b += m), n === "sticky" && u.current)) {
        var O = u.current.getBoundingClientRect(), R = O.left, E = O.right;
        g && (g += R), m && (m += E);
      }
      if (c === "vertical" && (S && (b += S), y && (b += y), n === "sticky" && u.current)) {
        var D = u.current.getBoundingClientRect(), z = D.top, C = D.bottom;
        S && (S += z), y && (y += C);
      }
      return l = H(i), /* @__PURE__ */ $.createElement(a, l.cn("SScrollBar", W({}, L({
        left: c === "horizontal" && g ? "".concat(g, "px") : void 0,
        right: c === "horizontal" && m ? "".concat(m, "px") : void 0,
        top: c === "vertical" && S ? "".concat(S, "px") : void 0,
        bottom: c === "vertical" && y ? "".concat(y, "px") : void 0,
        offsetSum: "".concat(b, "px"),
        role: h ? void 0 : "scrollbar",
        "aria-hidden": h ? "true" : void 0,
        ref: this.refBar,
        "aria-valuemin": h ? void 0 : 0,
        "aria-controls": h ? void 0 : "igc-".concat(o, "-scroll-container"),
        "aria-orientation": h ? void 0 : this.getOrientation(),
        onMouseDown: this.handleMouseDownBar,
        orientation: this.getOrientation()
      }, r))));
    }
  }]), d;
}(V);
s(x, "displayName", "Bar");
s(x, "style", I);
s(x, "enhance", [N(j, "hideFromScreenReaders")]);
s(x, "defaultProps", function() {
  return {
    container: /* @__PURE__ */ $.createRef(),
    children: /* @__PURE__ */ $.createElement(G.Slider, null)
  };
});
function q(B) {
  var v = arguments[0], d, t = B.styles, r = P;
  return d = H(t), /* @__PURE__ */ $.createElement(r, d.cn("SSlider", W({}, L({
    onDragStart: function() {
      return !1;
    }
  }, v))));
}
var G = U(x, {
  Slider: q
});
export {
  k as DEFAULT_SLIDER_SIZE,
  G as default,
  j as hideScrollBarsFromScreenReadersContext,
  Z as setAreaValue
};
